import store from '@/store'
import { sync } from 'vuex-router-sync'

export default function configureRouterStore(router) {
  sync(store, router, { moduleName: 'router' })
}
